// РАЗБОР ПО ССЫЛКЕ ИЗ ПИСЬМА — `/r/{token}` (Supabase, часть 1, п. 4). Слепок с сервера → тот же
// документ, что окно Open шага 7: `documentHtml` + пагинация §II `paginateWindow` (`s7Document.js`).
// Второго рендерера нет — разница с Open только в том, откуда пришёл паспорт.
//
// ⭐ ДОКУМЕНТ ЗАМЕНЯЕТ СТРАНИЦУ ЦЕЛИКОМ (`document.write`), а не встаёт фреймом: Open — самостоятельный
// HTML со своими `r10*.css`, подгонкой и печатью; во фрейме печать и подгонка по окну сломались бы.
//
// ⭐ SAVE PDF (строка 67, `s987.d1`): сборка PDF заказывается при открытии слепка — до нажатия; кнопка
// «Save PDF» в углу документа читает склад вкладки (`pdfStore.js`). Дата документа — дата слепка.
//
// Неизвестный, просроченный и кривой токен — один экран 404 визарда (`NotFound`, копи `notFoundCopy.js`):
// честное «такого нет» без подробностей. ⚠️ Сбой связи печатает тот же экран — своей копи у него нет
// ([TODO: UI text — ask Kirill/web-Claude], записано в тикете).

import { useEffect, useState } from 'react';

import { NotFound } from '../wizard/StubScreen.jsx';
import { loadSnapshot } from '../send/snapshot.js';
import { documentHtml, paginateWindow } from '../wizard/steps/s7Document.js';
import { pdfStore } from '../pdf/pdfStore.js';
import { attachSaveButton } from '../pdf/saveButton.js';

/** Документ слепка поверх текущей страницы + пагинация §II, как у окна Open; PDF — заранее. */
export function writeReading(snapshot, win = window, pdf = pdfStore, doc = { documentHtml, paginateWindow }) {
  const opts = { generatedAt: snapshot.generatedAt, pdf };
  pdf.prebuild(snapshot.passport, snapshot.generatedAt);
  const d = win.document;
  d.open();
  d.write(doc.documentHtml(snapshot.passport, opts));
  d.close();
  attachSaveButton(win, pdf, win);
  doc.paginateWindow(win, snapshot.passport, opts, win);
}

export default function ReadingPage({ token, load = loadSnapshot, write = writeReading }) {
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    let alive = true;
    load(token).then((r) => {
      if (!alive) return;
      if (r.ok) write(r.snapshot);
      else {
        console.info('[reading] snapshot not opened:', r.reason);
        setMissing(true);
      }
    });
    return () => { alive = false; };
  }, [token, load, write]);
  if (missing) return <NotFound />;
  return <div data-testid="reading-loading" style={{ minHeight: '100vh', background: '#0a0b0d' }} />;
}
